import React from "react";
import { Modal } from "react-bootstrap";
import CommonButton from "../../../components/commonButton";
import withModal from "../../../components/withModal";
import CustomSelect from "../../../components/form/CustomSelect";
import { CheckboxOption, multiMessageStyle, MultiValueMessage } from "../../../components/form/utils";

const RequirementFilterModalInner = ({
    onClose,
    categories,
    filterValues,
    setFilterValues,
    fetchStatesOptions,
    fetchCitiesOptions,
    onApply,
    onClear,
}) => {
    const handleApply = () => {
        onApply();
        onClose();
    };

    const handleClear = () => {
        onClear();
        onClose();
    };

    return (
        <>
            <Modal.Body className="grid gap-4">
                <CustomSelect
                    className="g-col-12"
                    isMulti
                    label={{ name: "Categories" }}
                    isSearchable
                    options={(categories || []).map((parent) => ({
                        label: parent.name,
                        options: (parent.subcategories || []).map((sub) => ({
                            value: sub.id,
                            label: sub.name,
                        })),
                    }))}
                    value={
                        categories
                            ?.flatMap((p) => p.subcategories || [])
                            ?.filter((s) => filterValues.category_id.includes(s.id))
                            ?.map((s) => ({ value: s.id, label: s.name })) || []
                    }
                    onChange={(selected) =>
                        setFilterValues((prev) => ({
                            ...prev,
                            category_id: selected ? selected.map((s) => s.value) : [],
                        }))
                    }
                    placeholder="Search & Select Categories"
                />
                <CustomSelect
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    showSelectAll
                    label={{ name: "States" }}
                    name="state_id"
                    value={filterValues.state_id}
                    onChange={(name, val) =>
                        setFilterValues((prev) => ({ ...prev, state_id: val, city_id: [] }))
                    }
                    fetchOptions={fetchStatesOptions}
                    placeholder="Search States"
                    selectProps={{
                        components: { Option: CheckboxOption, MultiValue: (props) => <MultiValueMessage {...props} message="States Selected" /> },
                        styles: multiMessageStyle
                    }}
                    className="g-col-6"
                />
                <CustomSelect
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    selectProps={{
                        components: { Option: CheckboxOption, MultiValue: (props) => <MultiValueMessage {...props} message="Cities Selected" /> },
                        styles: multiMessageStyle
                    }}
                    showSelectAll
                    label={{ name: "Cities" }}
                    name="city_id"
                    value={filterValues.city_id}
                    onChange={(name, val) =>
                        setFilterValues((prev) => ({ ...prev, city_id: val }))
                    }
                    fetchOptions={fetchCitiesOptions}
                    className="g-col-6"
                    placeholder="Search Cities"
                    isDisabled={!filterValues.state_id || filterValues.state_id.length === 0}
                />

            </Modal.Body>
            <Modal.Footer >
                <CommonButton title="Clear All" variant="secondary" onClick={handleClear} />
                <CommonButton title="Apply Filters" variant="primary" onClick={handleApply} />
            </Modal.Footer>
        </>
    );
};

const RequirementFilterModal = withModal(RequirementFilterModalInner);

export default RequirementFilterModal;